import { computed, defineComponent, ref } from '@vue/composition-api';
import { YOUTUBE_EMBED_REGEX, YOUTUBE_REGEX, YOUTUBE_VIDEO_ID_REGEX, } from '@/constants/object';
import { Modal } from '@/components/Modal';
import { useMobileView } from '@/composables';
export default defineComponent({
    components: { Modal },
    props: {
        link: String,
    },
    setup(props) {
        const { isMobileView } = useMobileView();
        const isYoutubeLink = computed(() => {
            return (!!props.link &&
                (YOUTUBE_REGEX.test(props.link) || YOUTUBE_EMBED_REGEX.test(props.link)));
        });
        const embedUrl = computed(() => {
            if (!props.link)
                return '';
            const match = props.link.match(YOUTUBE_VIDEO_ID_REGEX);
            const videoId = match ? match[1] : '';
            return videoId ? `https://www.youtube.com/embed/${videoId}` : props.link;
        });
        const showModal = ref(false);
        return { isYoutubeLink, showModal, isMobileView, embedUrl };
    },
});
